import { ScrollText, Network, Hand } from "lucide-react";
import type { FindingSource } from "@/lib/queries";
import { cn } from "@/lib/utils";

const STYLES: Record<FindingSource, { label: string; tone: string; Icon: typeof ScrollText }> = {
  audit: {
    label: "Audit",
    tone:  "bg-primary/10 text-primary border-primary/20",
    Icon:  ScrollText,
  },
  flow_rule: {
    label: "Flow rule",
    tone:  "bg-violet-500/10 text-violet-600 dark:text-violet-400 border-violet-500/20",
    Icon:  Network,
  },
  manual: {
    label: "Manual",
    tone:  "bg-muted text-muted-foreground border-border",
    Icon:  Hand,
  },
};

export function FindingSourceBadge({
  source, size = "sm",
}: {
  source: FindingSource;
  size?: "sm" | "xs";
}) {
  const s = STYLES[source] ?? STYLES.manual;
  const cls = size === "xs"
    ? "gap-1 px-1.5 py-0.5 text-[10px]"
    : "gap-1.5 px-2 py-0.5 text-xs";
  const iconCls = size === "xs" ? "h-2.5 w-2.5" : "h-3 w-3";
  return (
    <span
      className={cn(
        "inline-flex items-center rounded-full border font-medium",
        cls,
        s.tone,
      )}
      title={`Source: ${s.label}`}
    >
      <s.Icon className={iconCls} />
      {s.label}
    </span>
  );
}
